import { createSlice } from "@reduxjs/toolkit";
import { Worker } from "../models/Worker";

const WorkersInitialState: {
	workers: Worker[];
} = {
	workers: [],
};

export const WorkersReducer = createSlice({
	name: "__",
	initialState: WorkersInitialState,
	reducers: {
		setWorkers(state, { payload }) {
			state.workers = payload;
		},
	},
});
